/**
 * 権限管理ページ用のスクリプト
 */
if (is_route('group.index')) {
    $(function () {
        group_event_set();
        group_setting_event_set();
    });
}
window.group_event_set = function() {

    /*---- 設定画面表示時 ----*/

    // 設定画面表示時
    $(document).on('click', '[data-setting-modal]', function() {
        _modal.create(this, 'setting-modal', ['id', 'screen_key'], false, function() {
            group_displayed_default_permission_list();
            group_displayed_permission_list($('#group-setting-modal-type'));
        });
    });

    /*---- 設定保存時 ----*/

    // 設定保存時
    $(document).on('click', '[data-save-modal]', function () {
        // edit_settingの保存時にはload_contents()を呼ばないsubmitを行う
        if(this.id === 'edit_setting') {
            _modal.submit_no_load(this, 'save-modal');
            return;
        }
        _modal.submit(this, 'save-modal');
    });

    /*---- 削除確認時 ----*/

    // 削除確認時
    $(document).on('click', '[data-confirm-modal]', function () {
        _modal.create(this, 'confirm-modal', ['id']);
    });

    /*---- 削除時 ----*/

    // 削除時
    $(document).on('click', '[data-delete-modal]', function () {
        _modal.submit(this, 'delete-modal');
    });
    
}
window.group_setting_event_set = function() {

    /*---- モデルのチェックボックスクリック時 ----*/

    $(document).on('change', '.group-model', function() {
        let itemId = create_id($(this).data('parent-item-id'));
        // チェック項目が存在していなければindeterminateで表示
        $(this).prop('indeterminate', !($(itemId).find('.permission-tree input:checked').length > 0));
        if ($(this).prop('checked')) {
            $(itemId + ' .range-tree ').slideDown(100);
            group_set_visible_list_item_style();
        } else {
            $(itemId + ' .range-tree ').slideUp(100);
            $(itemId + ' .group-model-range-permission').prop('checked', false);
            $(itemId + ' .group-model-range').prop('checked', false);
            $(itemId + ' .group-model-range').prop('indeterminate', false);
            $(this).prop('indeterminate', false);
            // 詳細編集設定ボタンを非表示にする
            $(itemId + ' .group-model-range-permission-setting').addClass('display-none');
        }
    })

    /*---- レンジのチェックボックスクリック時 ----*/

    $(document).on('change', '.group-model-range', function() {
        let itemId = create_id($(this).data('parent-item-id'));
        let model = create_id($(this).data('parent-input-id'));
        $(this).prop('indeterminate', (!($(itemId).find('.permission-tree input:checked').length > 0)));
        if ($(this).prop('checked')) {
            $(itemId + ' .permission-tree ').slideDown(100);
            $(model).prop('checked', true);
        } else {
            $(itemId + ' .permission-tree').slideUp(100);
            $(this).prop('indeterminate', false);
            $(itemId + ' .group-model-range-permission').prop('checked', false);
            // 詳細編集設定ボタンを非表示にする
            $(itemId + ' .group-model-range-permission-setting').addClass('display-none');
        }
        $(model).trigger('change');
    });

    /*---- パーミッションのチェックボックスクリック時 ----*/

    $(document).on('change', '.group-model-range-permission', function () {
        // 親要素のparent-item-idを取得
        let itemId = create_id($(this).data('parent-item-id'));
        // 同階層がチェックされていない場合
        let range = create_id($(this).data('parent-input-id'));
        if ($(this).prop('checked')) { // チェックされる時
            // 親のチェック状態を指定
            $(range).prop('checked', true);

            // 詳細編集設定ボタンを表示する
            $(itemId + ' .group-model-range-permission-setting').removeClass('display-none');
        }
        else { // チェックが外れる時
            // 詳細編集設定ボタンを非表示にする
            $(itemId + ' .group-model-range-permission-setting').addClass('display-none');
        }
        $(range).trigger('change');
    });

    /*---- 権限タイプ変更時 ----*/

    $(document).on('change', '#group-setting-modal-type', function() {
        group_displayed_permission_list(this);
        $('#group-setting-modal-accessible_flag').prop('checked', false);
        $('#group-setting-modal-editable_flag').prop('checked', false);
        $('#group-setting-modal-deletable_flag').prop('checked', false);
    });

    /*---- 閲覧一括設定変更時 ----*/

    $(document).on('change', '#group-setting-modal-accessible_flag', function() {
        let range = $('#group-setting-modal-type').val();
        if (range != '') {
            range = ' [data-range=' + range + ']';
            console.log(range);
        }
        $('.model-tree-list-item' + range + ' [data-permission-group=accessible]').prop('checked', $(this).prop('checked'));
        $('.model-tree-list-item' + range + ' [data-permission-group=accessible]').trigger('change');
    });

    /*---- 設定一括設定変更時 ----*/

    $(document).on('change', '#group-setting-modal-editable_flag', function() {
        let range = $('#group-setting-modal-type').val();
        if (range != '') {
            range = ' [data-range=' + range + ']';
        }
        $('.model-tree-list-item' + range + ' [data-permission-group=editable]').prop('checked', $(this).prop('checked'));
        $('.model-tree-list-item' + range + ' [data-permission-group=editable]').trigger('change');
    });

    /*---- 削除一括設定変更時 ----*/

    $(document).on('change', '#group-setting-modal-deletable_flag', function() {
        let range = $('#group-setting-modal-type').val();
        if (range != '') {
            range = ' [data-range=' + range + ']';
        }
        $('.model-tree-list-item' + range + ' [data-permission-group=deletable]').prop('checked', $(this).prop('checked'));
        $('.model-tree-list-item' + range + ' [data-permission-group=deletable]').trigger('change');
    });

    /**---- 操作可、操作不可のテキストを押下時 ----*/
    $(document).on('click', '#edit-setting-modal .toggle-operation', function () {
        // input要素のテキストを操作可と操作不可で切り替える
        const $input = $(this);
        const enabledText = '操作可';
        const disabledText = '操作不可';
        const currentText = $input.text();
        // 現在の文字が操作可になっているかを判定
        const isCurrentlyEnabled = currentText === enabledText;
        // 操作可だったら次は操作不可に、操作不可だったら次は操作可に変更する
        const nextState = isCurrentlyEnabled ? 'disabled' : 'enabled';
        $input.data('state', nextState);
        $input.text(nextState === 'enabled' ? enabledText : disabledText);
        // 操作可なら背景を白色に変更し、操作不可なら背景を灰色(白色指定なし)に変更する
        $input.toggleClass('is-state-disabled', nextState === 'disabled');
        $input.toggleClass('bg-white');

        // 操作可/操作不可を0/1で持つhidden要素
        $input.siblings(`input[name="${$input.attr('name')}"]`).val(nextState === 'enabled' ? '0' : '1');
    });
}
window.group_displayed_default_permission_list = function () {
    $('.group-model-range-permission:checked').each(function() {
        let permissionTreeId = create_id($(this).data('parent-tree-id'));
        $(permissionTreeId).show(0, function() {
            let rangeTreeId = create_id($(this).parents('.range-tree-list-item').data('parent-tree-id'));
            $(rangeTreeId).show(0);
        });
    });
}
window.group_displayed_permission_list = function (elm) {
    let formId = '#group-setting-modal-form';
    if ($(elm).val() == '') {
        $(formId).find('.range-tree-list-item').each(function() {
            $(this).show(0, function() {
                let parentItemId = create_id($(this).data('parent-item-id'));
                $(parentItemId).show(0, function() {
                    group_set_visible_list_item_style();
                });
            });
        });
    } else {
        let target = '[data-range=' + $(elm).val() +']';
        $(formId).find('.range-tree-list-item:not(' + target + ')').hide(0, function() {
            $(this).find('input').prop('checked', false);
            $(this).find('input').prop('indeterminate', false);
            $(this).slideUp(0);
            $(this).find('.permission-tree').slideUp(0);
            let rangeTree = create_id($(this).data('parent-tree-id'));
            let modelItem = create_id($(this).data('parent-item-id'));
            if ($(rangeTree).find(target).length == 0) {
                $(modelItem).hide(0, function() {
                    $(modelItem).find('.group-model').prop('checked', false);
                    $(modelItem).find('.group-model').prop('indeterminate', false);
                });
            }
        });
        $(formId).find('.range-tree-list-item' + target).show(0, function() {
            let rangeTree = create_id($(this).data('parent-tree-id'));
            let modelItem = create_id($(this).data('parent-item-id'));
            if ($(rangeTree).find(target).length != 0) {
                $(modelItem).show(0, function() {
                    $(modelItem).find('.group-model').trigger('change');
                    group_set_visible_list_item_style();
                });
            }
        });
    }
    // 詳細編集設定ボタンを非表示にする
    if ($(elm).val() !== '' && $(elm).val() !== 'user_normal') {
        $('.group-model-range-permission-setting').addClass('display-none');
    }
}
window.group_set_visible_list_item_style = function () {
    let modalTree = $('#group-setting-modal-form').find('.model-tree');
    let li = '.model-tree-list-item';
    $(modalTree).find(li).removeClass('last-child');
    $(modalTree).find(li + ':visible:last').addClass('last-child');
    $(modalTree).find(li + ':visible').each(function() {
        let rangeTree = $(this).find('.range-tree');
        let li = '.range-tree-list-item';
        $(rangeTree).find(li).removeClass('last-child');
        $(rangeTree).find(li + ':visible:last').addClass('last-child');
        $(rangeTree).find(li + ':visible').each(function() {
            let tree = $(this).find('.permission-tree');
            let li = '.permission-tree-list-item';
            $(tree).find(li).removeClass('last-child');
            $(tree).find(li + ':visible:last').addClass('last-child');
        });
    });
}